
import {
  CategoryMixin
} from "~/node_modules/sitis-nuxt/lib/mixins";
import {
  Product
} from "~/node_modules/sitisjs/dist/internal/sections/products/models/Product";
import Breadcrumbs from "~/components/UI/Breadcrumbs.vue";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "Category",

  fetch: async function () {
    this.$store.commit('appState/setLoading', { category: true });
    this.$store.commit('catalog/setCategory', null);
    this.$store.commit('categoryFilters/setLoading', { key: 'get', value: true });
    this.$store.commit('categoryFilters/setFilters', []);
    await this.loadCategoryDetailed();
    await this.loadCategory(false);
    this.$store.commit('appState/setLoading', { category: false });
  },
  data: function () {
    return {
      productList: [],
    }
  },
  head: function () {
    const description = this.category?.seo?.description || this.category?.metaDescription || "";

    const title = (this.category?.seo?.title || this.category?.name || this.category?.dynamicFields?.catalog_banner_title || "").replace("<br/>", " ");
    const city = this.$store.state?.appState?.config?.city?.data?.prepositional;
    // const fullTitle = [title, 'в', city].filter((t) => !!t).join(" ")
    const fullTitle = title;

    return {
      title: fullTitle,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(fullTitle, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },

  components: {
    Breadcrumbs
  },

  mixins: [
    CategoryMixin
  ],

  computed: {
    breadcrumbs: function () {
      const categoryParent = this.category?.dynamicFields?.parent || {};

      let items = [
        { title: "Главная", path: "/" },
        { title: categoryParent?.name, path: "/transport" },
        { title: this.category?.name, path: this.$route.path },
      ];

      return items
    },
    faqBlockValue: function () {
      return {
        categoryId: this.category?.id,

        useApi: true
      }
    },
    articlesBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },
    calculatorBlockValue: function () {
      const freightCalculatorTitle = this.category.dynamicFields?.freight_calculator_title || "";
      return {
        title: freightCalculatorTitle || this.category?.dynamicFields?.catalog_banner_title || this.category?.name,
        subtitle: [
          this.category?.dynamicFields?.catalog_banner_subtitle,
          this.category?.dynamicFields?.catalog_banner_caption,
          this.category?.dynamicFields?.catalog_banner_caption_2,
          this.category?.dynamicFields?.catalog_banner_caption_3,
        ].filter((t) => !!t).join('<br/>'),
        image: this.category?.dynamicFields?.catalog_banner_image || this.category?.imageId,
        categoryId: this.category.id,

        dark: true,
        useH1: true,
        customBlueTitle: true
      }
    },
    ourFleetVehiclesTemplateBlockValue: function () {
      const categoryNameGenitiveCase =
          this.category?.dynamicFields?.category_name_genitive_case ||
          this.category?.name ||
          ""

      return {
        category: this.category,
        products: this.products,
        pagination: {
          ...this.pagination,
          pageCount: this.pageCount
        },

        categoryTitle: `Наш парк ${categoryNameGenitiveCase}`,

        filters: this.filters,
        selectedFilters: this.selectedFilters,
        isHideFilter: true,

        onChangePage: this.onChangePage.bind(this),
        onResetFilter: this.clearFilters.bind(this),
        searchProducts: this.searchProducts.bind(this),
        getUpdateFilters: this.getUpdateFilters.bind(this),
        onChangeFilterVariant: this.onChangeFilterVariant.bind(this),
      }
    },
    typesImageFeaturesBlockValue: function () {
      return {
        products: this.productList
      }
    },
    ourTransportBannerBlockValue: function () {
      return {
        categoryId: this.category.id,
        title: this.category?.dynamicFields?.our_transport_banner_title,
        image: this.category?.dynamicFields?.our_transport_banner_image,
        information: this.category?.dynamicFields?.our_transport_banner_information,
        visible_button: this.category?.dynamicFields?.our_transport_banner_visible_button,
      }
    },
    ourTransportOperationalTransportBlockValue: function () {
      return {
        title: this.category?.dynamicFields?.our_transport_operational_transport_title,
        subtitle: this.category?.dynamicFields?.our_transport_operational_transport_subtitle,
        text_button: this.category?.dynamicFields?.our_transport_operational_transport_button_Text,
        products: this.products
      }
    },
    ourTransportCargoListBlockValue: function () {
      return {
        title: this.category.dynamicFields?.our_transport_cargo_list_title || "",
        list: this.category.dynamicFields?.our_transport_cargo_list_list || "",
      }
    },
    ourTransportTransportationStagesBlockValue: function () {
      return {
        title: this.category.dynamicFields?.our_transport_transportation_stages_title || "",
        subtitle: this.category.dynamicFields?.our_transport_transportation_stages_subtitle || "",
      }
    },
    freightCalculatorBlockValue: function () {
      return {
        title: `Получить расчет перевозки`,
        cargoName: this.category?.dynamicFields?.freight_calculator_cargo_name || ""
      }
    },
    directionsCompletedProjectsBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },

    afterCmsPageId: function () {
      return this.category?.dynamicFields?.after_cms_page_id || null
    },
    extensions: function () {
      return ['short_characteristics', 'seo_title', 'characteristics']
    },
    extensionsCategory: function () {
      return ['parent']
    },
    defaultPerPage: function () {
      return 999
      return Boolean(this.$store.state.device?.device?.isMobile) ? 3 : 6
    }
  },

  watch: {
    filters: async function () {
      await this.getProductList();
    },
  },

  mounted: async function () {
    await this.getProductList();
  },

  methods: {
    getProductList: async function () {
      if ((this.filters || []).length <= 0) {
        return
      }

      const slugs = ["tip-gruza", "otrasli"];
      let filters = [];
      [...(this.filters || [])]
        .filter((t) => Boolean(slugs.includes(t.slug)))
        .map((filter) => {
          (filter?.variants || []).map((variant) => {
            filters.push(`filter[${filter.slug}][]=${variant.slug}`)
          });
        });

      let url = [
        'page=1',
        'group=1',
        'per-page=999'
      ];
      url.push(filters.join("&"))

      // Ищем подходящие товары
      const products = await this.$api.agent.transport.get(`/categories/catalog/products?${ url.join('&') }`).then((res) => {
        return (res.data || []).map((product) => {
          return new Product(product)
        })
      }).catch(() => {
        return []
      });
      if (products.length <= 0) {
        return
      }

      this.productList = products;
    },
  }
}
